/**
* 数据格式化
*/

import CryptoJS from 'crypto-js'
import { encrypt, decrypt } from './jsencrypt'
import cheerio from 'cheerio'

const EFormat = {

    // HTML转化为Vnode对象
    toVNode ( html ) {

    },

    // 转为bool类型
    boolVal ( txt, defaultVal ) {
        defaultVal = defaultVal || false

        if (typeof txt == 'undefined') {
            return defaultVal
        }

        if (typeof txt == 'boolean') {
            return txt
        } else if (typeof txt == 'number') {
            return !!txt
        } else {
            return (txt == '0' || txt == 'false') ? false : true
        }
    },

    // base64编码
    base64encode ( str ) {
        return btoa(unescape(encodeURIComponent(str)))
    },

    // base64解码
    base64decode ( str ) {
        return decodeURIComponent(escape(atob(str)))
    },

    // MD5加密
    md5 ( str ) {
        return CryptoJS.MD5(str).toString()
    },

    // 加密
    encrypt ( str ) {
        return encrypt(str)
    },

    // 解密
    decrypt ( str ) {
        return decrypt(str)
    }
}

export default EFormat